
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import api from '../services/api';

const BlogDetailsPage = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [previousPost, setPreviousPost] = useState(null);
  const [nextPost, setNextPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await api.getPublic(`blogs/${id}`);
        setPost(response.blog);
        setPreviousPost(response.previousBlog);
        setNextPost(response.nextPost);
      } catch (error) {
        setError(error.message);
      }
      setLoading(false);
    };

    fetchPost();
  }, [id]);

  if (loading) {
    return <div className="text-center py-20">Loading...</div>;
  }

  if (error) {
    return <div className="text-center py-20">Error: {error}</div>;
  }

  if (!post) {
    return <div className="text-center py-20">Blog post not found.</div>;
  }

  return (
    <div className="bg-[#264864] text-white">
      <style>{`
        .prose {
          color: white;
        }
        .prose iframe {
          width: 100%;
          height: 400px;
          border-radius: 10px;
        }
        .ql-size-small {
          font-size: 0.75em;
        }
        .ql-size-large {
          font-size: 1.5em;
        }
        .ql-size-huge {
          font-size: 2.5em;
        }
        .ql-font-arial {
          font-family: Arial, sans-serif;
        }
        .ql-font-georgia {
          font-family: Georgia, serif;
        }
        .ql-font-times-new-roman {
          font-family: 'Times New Roman', Times, serif;
        }
        .ql-font-verdana {
          font-family: Verdana, Geneva, sans-serif;
        }
      `}</style>
      <Header />
      <div className="container mx-auto px-6 py-12 pt-24">
        <article className="max-w-4xl mx-auto">
          {/* Back to Blog Link */}
          <div className="mb-8">
            <Link to="/blog" className="text-[#35a89d] hover:text-[#2e897c] transition-colors duration-300">
              &larr; Back to Blog
            </Link>
          </div>

          {/* Post Header */}
          <header className="mb-12 text-center">
            <h1 className="text-5xl font-extrabold mb-4">{post.title}</h1>
            <div className="text-lg text-white/70">
              <span>By {post.author}</span>
              <span className="mx-3">|</span>
              <span>{new Date(post.date).toLocaleDateString()}</span>
            </div>
          </header>

          {/* Featured Image */}
          <img src={`${process.env.REACT_APP_API_BASE_URL}/${post.imageUrl}`} alt={post.title} className="w-full h-auto max-h-[500px] object-cover rounded-xl shadow-lg mb-12"/>

          {/* Post Content */}
          <div
            className="prose prose-lg max-w-none text-white prose-headings:text-white prose-strong:text-white prose-a:text-[#35a89d] hover:prose-a:text-[#2e897c]"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />

          {/* Navigation */}
          <div className="flex justify-between mt-12">
            {previousPost && (
              <Link to={`/blog/${previousPost.id}`} className="text-[#35a89d] hover:text-[#2e897c] transition-colors duration-300">
                &larr; Previous Post
              </Link>
            )}
            {nextPost && (
              <Link to={`/blog/${nextPost.id}`} className="text-[#35a89d] hover:text-[#2e897c] transition-colors duration-300">
                Next Post &rarr;
              </Link>
            )}
          </div>

        </article>
      </div>
      <Footer />
    </div>
  );
};

export default BlogDetailsPage;

